<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="New Category" scrollable hide-footer size="sm">
            <template v-slot:modal-title>
                <span>New Category:</span>
            </template>

            <b-form @submit.stop.prevent="createCategory">
                <b-row>
                    <b-col>
                        <b-form-group
                            id="input-group-name"
                            label="Name:"
                            label-for="input-name"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-name"
                                v-model="create.name"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-form-row class="button-row">
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Creating...
                            </span>
                            <span v-else>Create</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [

		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-inventory-categories-create-category',
                create: {},
                submitting: 0,
			}
		},

		methods: {
            createCategory() {
                this.submitting = 1
                let createData = this.create

                let url = 'api/inventory/categories/createcategory'
                axios.post(url, {
                    createData
                })
                .then((res) => {
                    this.submitting = 0

                    let status = res.data.status
                    if (status == 'success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Category Created', 'Category created successfully!')
                        this.$emit('getCategories')
                    } else if (status == 'duplicate') {
                        this.showAlertBox('success', 'Duplicate Category', 'Category already exists! Please try something else!')
                    } else {
                        this.showAlertBox('error', 'Error', 'Error creating category!')
                    }
                }, () => {
                    this.has_error = true
                })
            }
		},

		computed: {

		},

		mounted() {

		}
	}
</script>
<style lang="scss">
    #modal-inventory-categories-create-category {
        .modal-content {
            .button-row {
                margin-top: 15px;
            }
        }
    }
</style>
